const optionInfinite = {
  infinite: true,
  arrows: false,
  swipe: false,
  dots: false,
  variableWidth: true,  // スライド幅の自動計算を無効
  autoplay: true,
  autoplaySpeed: 0,
  speed: 15000,
  cssEase: "linear",
  pauseOnFocus: false,
  pauseOnHover: false,
  useTransform: false,
}
const optionInfiniteRtl = {
  infinite: true,
  arrows: false,
  swipe: false,
  dots: false,
  variableWidth: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 15000,
  cssEase: "linear",
  rtl: true, // dir='rtl'とセットで逆方向にスライド
  pauseOnFocus: false,
  pauseOnHover: false,
  useTransform: false,
}

const optionSectionProduct = {
  infinite: true,
  arrows: true,
  variableWidth: true,
  appendArrows: $('.slider-arrows'),
  swipe: true,
  dots: false,
  mobileFirst: false, // ← デスクトップファーストに変更
  slidesToShow: 3,    // ← 基準（最大幅）での表示枚数
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 992,     // 992px以下になったら…
      settings: {
        slidesToShow: 2,   // → 2枚表示
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 574,     // 574px以下になったら…
      settings: {
        slidesToShow: 1,   // → 1枚表示
        slidesToScroll: 1,
        infinite: false,
        swipe: false
      }
    }
  ]
};

jQuery(function($){
  const slickInfinite = $('.slider1');
  const slickInfiniteRtl = $('.slider2');
  $(slickInfinite).slick(optionInfinite);
  $(slickInfiniteRtl).slick(optionInfiniteRtl);

  function initializeSlick() {
    const $slider = $('.top_products_slider');

    // 574px以上なら slick を有効化
    if ($(window).width() >= 574) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick(optionSectionProduct);
      }
    } else {
      // 574px未満なら slick を破棄
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  // 初回
  initializeSlick();

  // リサイズ時
  $(window).on('resize', function() {
    initializeSlick();
  });
  
});

